import { useCurrentUser } from '@hotjar/user';
import { useUserExperiment } from '../../../external-dependencies/webapp-utils';
import type { ExternalProductAllowances, ProductCatalogOptions } from '../types';
import { useCanSeeExperimentChurnDeflectionModalV1 } from './useCanSeeExperimentChurnDeflectionModalV1';

const EXPERIMENT_ID = 'reng_churn_deflection_modal_v1';

/**
 * Experiment: Churn Deflection Modal V1
 * @see {@link https://app.optimizely.com/v2/projects/15029550136/experiments/23599920462/variations|View experiment on Optimizely}
 */
export function useExperimentChurnDeflectionModalV1(
  productsToDowngrade: ExternalProductAllowances,
  productCatalogOptions: ProductCatalogOptions,
): boolean {
  const canSeeExperiment = useCanSeeExperimentChurnDeflectionModalV1(
    productsToDowngrade,
    productCatalogOptions,
  );
  const { data: user } = useCurrentUser();
  const { inVariant1 } = useUserExperiment(EXPERIMENT_ID, user, canSeeExperiment);

  return inVariant1;
}
